export default __webpack_public_path__ + "static/media/Prosjektrapport Design thinking program for Biomarin industri.9d642479.pdf";